export default __webpack_public_path__ + "static/media/logo-marketplace.ba43f6ae.png";